<template>
  <div id="pagination">
    <paginate
      :click-handler="clickHandler"
      :container-class="'pagination'"
      :prev-class="'prev-item'"
      :next-class="'next-item'"
      :page-class="'page-item'"
      :page-count="pageCount"
      :prev-text="'<'"
      :next-text="'>'"
      v-model="current_page">
    </paginate>
  </div>
</template>

<script>
import Paginate from 'vuejs-paginate'

export default {
  name: 'Pagination',
  components: {
    Paginate
  },
  data: () => ({
    current_page: 0
  }),
  props: {
    clickHandler: {
      type: Function,
      required: true
    },
    page: {
      type: Number,
      required: true
    },
    pageCount: {
      type: Number,
      required: true
    }
  },
  mounted () {
    this.current_page = this.page
  }
}
</script>

<style lang="scss">
  .pagination {
    justify-content: center;
  }

  .page-item {
    margin-left: 1%;
    margin-right: 1%;
  }

  .page-item > a {
    color: #000000;
    font-weight: normal;
  }

  .page-item > a:active,
  .page-item > a:focus,
  .page-item > a:hover {
    outline: none;
    text-decoration: none;
    color: #000000;
    font-weight: normal;
  }

  .page-item.active > a {
    color: #000000;
    font-weight: bold;
  }

  .next-item > a {
    color: #000000;
    font-weight: normal;
  }

  .next-item > a:active,
  .next-item > a:focus,
  .next-item > a:hover {
    outline: none;
    text-decoration: none;
    color: #000000;
    font-weight: normal;
  }

  .prev-item {
    display: none;
  }

  a {
    color: #000000;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue